import {
  Resolve,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/internal/operators';
import { Lab } from '../modals/lab.model';
import { LabService } from '../services/lab.service';
import { EventEmitterService } from '@teams-auth';
import { EventService } from '../services/event.services';
import { tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AttendeeLabResolver implements Resolve<any> {
  constructor(private labSrv: LabService, private eventEmitter: EventEmitterService, private eventSrv: EventService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<Lab> {
    if (route.params.voucherCode !== 'anonymous') {
      return this.labSrv.getAttendeeLab(route.params.voucherCode).pipe(
        tap((res: Lab) => {
          this.eventSrv.attendeeLab.next(res);
        }),
        catchError((error) => {
          const code = 'Error - 70001';
          this.eventEmitter.debugAlert(code, error.error);
          this.eventSrv.attendeeLab.next(null);
          return of(null);
        })
      );
    } else {
      const code = 'Error - 70002';
      this.eventEmitter.debugAlert(code, "Error getting Labs")
      this.eventSrv.attendeeLab.next(null); 
      return of(null);
    }
  }
}
